export async function downloadImage(imageSrc: string, name = 'unnamed') {
  if (!imageSrc) {
    return
  }

  const { data } = await useFetch(imageSrc, {
    deep: true,
  })
  const image = data.value

  if (!(image instanceof Blob)) {
    return
  }

  const link = document.createElement('a')
  link.href = URL.createObjectURL(image)
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  return link
}

export function downloadBase64Image(base64: string, name = 'unnamed') {
  const a = document.createElement('a')
  a.href = base64
  a.download = name
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function downloadFile(url: string, name = 'unnamed') {
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
